export default __webpack_public_path__ + "static/media/daynight_blu.3ba76607.png";